import {
  Alert,
  Icon,
  Link,
  Typography,
  useWindowSize,
} from '@breeze-ai/ui-library';
import { Button } from '@breezeai-frontend/cargo-ui';

import { useDTCFlowContext } from '../../context/hooks';
import styles from './InsuranceSuccessPage.module.scss';

export const InsuranceSuccessPage = () => {
  const { isMobile } = useWindowSize();
  const { brand, customer } = useDTCFlowContext();
  const { supportMail, homepageUrl } = brand;
  const { email } = customer ?? {};

  return (
    <div className={styles.successPage} data-testid="dtc-success-page">
      <Icon icon="check-circle" className={styles.icon} />
      <div className={styles.text}>
        {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
        <Typography level={isMobile ? 'h3' : 'h2'}>Almost there!</Typography>
        {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
        <Typography block>
          An email including your insurance documents and{' '}
          {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
          <Typography bold>a payment link</Typography> has been sent to{' '}
          <Typography bold role="customer-email">
            {email}
          </Typography>
          .
        </Typography>
      </div>
      <Alert variant="warning" className={styles.alert} role="payment-alert">
        <Typography block>
          {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
          <Typography bold>Note:</Typography> Failure to pay before the shipment
          departure date will result in the cancellation of your policy.
        </Typography>
      </Alert>
      <Link href={homepageUrl} underline={false}>
        <Button variant="secondary" width="fixed" label="Back to Home Page" />
      </Link>
      {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
      <Typography block className={styles.supportMail} role="support-email">
        Need help? Drop us an email{' '}
        <Link href={`mailto:${supportMail}`} underline={false}>
          {supportMail}
        </Link>
      </Typography>
    </div>
  );
};
